import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { UnsavedChangesService } from '../../services/common/unsaved-changes.service';
import { CommonFunctionsService } from '../../services/common-functions.service';

/** Blocks router navigation while a registered screen has unsaved changes. */
export const unsavedChangesGuard: CanDeactivateFn<unknown> = () =>
    // A forced session-expiry redirect to /login must never be blocked.
    sessionStorage.getItem(CommonFunctionsService.SESSION_EXPIRED_FLAG) === 'true'
    || inject(UnsavedChangesService).confirmLeave();
